<template>
  <v-container fluid>
    <a-space>
      <v-btn color="success" tile @click="showadd">
        <v-icon small>mdi-plus</v-icon>新增油价
      </v-btn>
      <v-btn color="primary" tile outlined @click="getdata()">
        <v-icon small>mdi-reload</v-icon>刷新
      </v-btn>
    </a-space>
    <v-tabs v-model="tab" @change="getdata()">
      <v-tab v-for="(item, index) in tabs" :key="item.value" :tab-value="index"> {{ item.text }} </v-tab>
    </v-tabs>
    <v-card tile class="mt-2">
      <v-data-table dense :headers="headers" :items="list" :items-per-page="limit" no-data-text="无数据"
        hide-default-footer disable-sort :height="height" fixed-header>
        <template v-slot:item.index="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.rate="{ item }">
          <span>{{ item.rate }} %</span>
        </template>
        <template v-slot:item.postlines="{ item }">
          <p v-for="(pitem, index) in item.postlines" :key="index">{{ pitem }}</p>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn text color="success" @click="showedit(item)"> 编辑 </v-btn>
          <a-popconfirm title="删除" ok-text="确定" cancel-text="取消" @confirm="remove(item._id)">
            <v-btn text color="error"> 删除 </v-btn>
          </a-popconfirm>
        </template>
      </v-data-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="model" persistent max-width="400px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            {{ modeltitle }}
            <v-icon @click="cancelsave">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container style="max-height:600px;overflow-y:auto;">
              <v-row>
                <v-col v-if="form.type === '2'" cols="12">
                  <v-autocomplete v-model="form.postofficeid" :items="postoffices" :rules="[vrules.required]" outlined
                    dense :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" disabled>
                    <template v-slot:label>
                      邮局 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-if="form.type === '3'" cols="12">
                  <v-autocomplete v-model="form.section" :items="sections" :rules="[vrules.required]" outlined dense
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" disabled>
                    <template v-slot:label>
                      标段 <span class="red--text">*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete v-model="form.postlineids" :items="fpostlines" outlined dense
                    :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" clearable multiple>
                    <template v-slot:label>
                      线路
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-menu ref="month_menu" v-model="month_menu" :close-on-content-click="false"
                    :return-value.sync="form.month" transition="scale-transition" min-width="auto" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="form.month" :rules="[vrules.required]" append-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" dense outlined>
                        <template v-slot:label>
                          月份 <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.month" type="month" no-title value="YYYY-mm" scrollable locale="zh-cn"
                      @input="() => { $refs.month_menu.save(form.month); month_menu = false; }"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="form.rate" type="number" :rules="[vrules.required]" label="油价浮动"
                    placeholder="油价浮动比例,上浮大于0,下浮小于0" suffix="%" persistent-placeholder dense outlined>
                    <template v-slot:label>
                      油价浮动 <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" tile :disabled="!valid" @click="save">确定</v-btn>
            <v-btn tile @click="cancelsave">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "PostOfficeOliPrice",
  data() {
    return {
      tab: 0,
      tabs: [],
      headers: [
        { text: "序号", value: "index", align: "center", width: 100 },
        { text: "月份", value: "month", align: "center", width: 100 },
        { text: "油价浮动", value: "rate", align: "center", width: 100 },
        { text: "线路", value: "postlines", align: "center", width: 200 },
        { text: "操作", value: "action", width: 180 },
      ],
      page: 1,
      limit: 50,
      list: [],
      length: 0,
      count: 0,
      model: false,
      modeltitle: "",
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      postoffices: [],
      sections: [],
      postlines: [],
      month_menu: false,
      valid: true,
      form: {},
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    fpostlines() {
      let tabitem = this.tabs[this.tab];
      if (tabitem) {
        if (tabitem.type === 'postoffice') {
          return this.postlines.filter(n => n.postofficeid === tabitem.value);
        }
        else if (tabitem.type === 'section') {
          return this.postlines.filter(n => n.section === tabitem.value);
        }
      }
      return [];
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 200;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 200;
    };
  },
  activated() {
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/oilprice/list", { tab: this.tab, page: this.page, limit: this.limit }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          this.tabs = res.data.tabs;
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
          this.tab = res.data.tab;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getinfo(_id) {
      this.$toast.loading({ message: "" });
      let tabitem = this.tabs[this.tab];
      let form = { _id };
      if (tabitem.type === 'postoffice') form.postofficeid = tabitem.value;
      if (tabitem.type === 'section') form.section = tabitem.value;
      return this.$api.doAPI("/oilprice/info", form).then((res) => {
        this.$toast.clear();
        // console.log(res);
        if (res.code === 0) {
          this.postoffices = res.data.postoffices;
          this.sections = res.data.sections;
          this.postlines = res.data.postlines;
          this.form = res.data.dataForm;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.getinfo().then(() => {
        this.modeltitle = "新增油价联动";
        this.model = true;
      });
    },
    showedit(item) {
      this.getinfo(item._id).then(() => {
        this.modeltitle = "编辑油价联动";
        this.model = true;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/oilprice/save", { dataForm: this.form }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.model = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelsave() {
      this.$refs.form.resetValidation();
      this.model = false;
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/oilprice/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

p {
  margin: 0;
}
</style>